function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { fonts } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpTextStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  color: colors.PRIMARY,
  fontSize: '16px',
  lineHeight: '135%',
  letterSpacing: '0.005em',
  variants: {
    /**
     * Alt text -- slightly lighter.
     */
    alt: {
      color: colors.PRIMARY_ALT,
      letterSpacing: '0.003em'
    },

    /**
     * Hero text -- slightly larger.
     */
    hero: {
      fontSize: '18px'
    },

    /**
     * Bold text -- it's bold.
     */
    bold: _objectSpread({}, fonts.GRAPHIK_MEDIUM),

    /**
     * Heavy text -- bolder.
     */
    heavy: _objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
      fontWeight: 500,
      letterSpacing: '0.04em'
    }),

    /**
     * Thin text -- slightly smaller and more space.
     */
    thin: {
      fontSize: '14px',
      letterSpacing: '0.05em'
    },

    /**
     * Rate callout -- larger and bolder.
     */
    rate: _objectSpread(_objectSpread({}, fonts.GRAPHIK_SEMIBOLD), {}, {
      fontWeight: 600,
      fontSize: '22px',
      lineHeight: '130%',
      letterSpacing: '0.05em',
      marginBottom: '10px'
    }),

    /**
     * Chip text -- smaller and bolder
     */
    chip: _objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
      fontSize: '12px',
      lineHeight: '130%',
      letterSpacing: '0.03em'
    }),

    /**
     * Footnote -- smaller and lighter
     */
    footnote: {
      fontSize: '12px',
      color: colors.PRIMARY_ALT,
      letterSpacing: '0.003em'
    },

    /**
     * Wrap -- Insert line breaks to prevent text from
     * overflowing its line box.
     */
    wrapped: {
      overflowWrap: 'normal',
      whiteSpace: 'normal'
    },

    /**
     * Error text that might be shown to an end-user, like if
     *   they put an incorrect value in an input.
     */
    error: {
      color: colors.ERROR,
      fontSize: '13px',
      letterSpacing: '0.1px',
      lineHeight: '21px'
    },

    /**
     * Error text that should never be shown to an end-user.
     *   ... Yeah right.
     */
    devError: {
      fontFamily: 'courier',
      fontWeight: 'bolder',
      color: colors.ERROR,
      fontSize: '12px'
    }
  }
}));